import { render, staticRenderFns } from "./Outfitters.vue?vue&type=template&id=8478d5f4&scoped=true&"
import script from "./Outfitters.vue?vue&type=script&lang=js&"
export * from "./Outfitters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8478d5f4",
  null
  
)

export default component.exports